<template>
  <v-menu offset-y :close-on-content-click="false">
    <template v-slot:activator="{ on, attrs }">
      <v-badge bordered dot color="error" overlap :value="isColumnsDirty"
        ><v-btn small text outlined v-on="on" :attrs="attrs" color="primary"
          ><v-icon>mdi-view-column</v-icon>Display</v-btn
        ></v-badge
      >
    </template>
    <v-card max-width="400px" style="overflow-y: auto">
      <v-card-text>
        <v-row dense justify="start">
          <v-col>
            <v-checkbox
              :input-value="isAllSelected"
              @change="selectAll"
              dense
              hide-details
              :disabled="isAllSelected"
              ><template v-slot:label
                ><span class="text-caption">Select All</span></template
              ></v-checkbox
            ></v-col
          ><v-col>
            <v-checkbox
              :input-value="isNoneSelected"
              @change="unselectAll"
              dense
              hide-details
              :disabled="isNoneSelected"
              ><template v-slot:label
                ><span class="text-caption">Unselect All</span></template
              ></v-checkbox
            ></v-col
          ></v-row
        >
        <v-divider></v-divider>
        <v-row dense justify="start">
          <v-col
            v-for="item in sortedColumns"
            :key="item.text"
            cols="12"
            sm="6"
            class="py-0"
          >
            <v-checkbox
              v-model="displayColumns"
              :value="item.value"
              :disabled="item.fixed"
              dense
              hide-details
              ><template v-slot:label
                ><span class="text-caption">{{ item.text }}</span></template
              ></v-checkbox
            >
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  props: ["columns"],
  mounted() {
    this.displayColumns = this.columns.map((x) => x.value);
  },
  computed: {
    isColumnsDirty() {
      return this.$store.getters["plansModule/isColumnsDirty"];
    },
    sortedColumns() {
      return this.columns.slice().sort((a, b) => a.text.localeCompare(b.text));
    },
    isAllSelected() {
      return this.displayColumns.length == this.sortedColumns.length;
    },
    isNoneSelected() {
      // only client name (fixed column)
      return this.displayColumns.length == 1;
    },
    displayColumns: {
      // getter
      get: function () {
        return this.$store.state.plansModule.displayColumns;
      },
      // setter
      set: function (newValue) {
        this.$store.dispatch("plansModule/setDisplayColumns", newValue);
      },
    },
  },
  methods: {
    selectAll() {
      this.$store.dispatch(
        "plansModule/setDisplayColumns",
        this.columns.map((x) => x.value)
      );
    },
    unselectAll() {
      // set display columns to only fixed column
      this.$store.dispatch(
        "plansModule/setDisplayColumns",
        this.columns.filter((x) => x.fixed).map((x) => x.value)
      );
    },
  },
};
</script>
